import angular from 'angular';
import { UploadDocumentosEmLoteService } from './upload-documentos-em-lote.service';

export const UploadDocumentosEmLoteListRouting = [
    '$stateProvider',
    function ($stateProvider: angular.ui.IStateProvider) {
        const accessResolve = [
            '$rootScope',
            '$state',
            '$q',
            function (
                $rootScope: angular.IRootScopeService & {
                    liberadoTela: (arg: string) => boolean,
                    temPermissao: (arg: string) => boolean,
                },
                $state: angular.ui.IStateService,
                $q: angular.IQService
            ) {
                if (
                    $rootScope.liberadoTela('LIBERAR_GED_TRABALHADOR') &&
                    $rootScope.temPermissao('visualizar_arquivos_trabalhadores')
                ) {
                    return true;
                }

                $state.go('dp');
                return $q.reject('Acesso negado ao módulo de upload de documentos em lote.');
            }
        ];

        const showResolve = {
            'access': accessResolve,
            'entity': [
                'access',
                'UploadDocumentosEmLoteService',
                '$stateParams',
                '$state',
                '$q',
                function (
                    _access: boolean,
                    entityService: UploadDocumentosEmLoteService,
                    $stateParams: angular.ui.IStateParamsService,
                    $state: angular.ui.IStateService,
                    $q: angular.IQService
                ) {
                    if (!$stateParams['uploaddocumento']) {
                        return $q<void>(() => $state.go('uploaddocumentoslote'));
                    }

                    return entityService.get($stateParams['uploaddocumento'])
                        .then((data) => {
                            return data;
                        })
                        .catch((error) => {
                            if (error.status === 404) {
                                return $q(() => $state.go('not_found', $stateParams));
                            }

                            return $q.reject(error);
                        });
                }
            ]
        };

        $stateProvider
            .state('uploaddocumentoslote', {
                url: '/documentos/upload-em-lote',
                template: require('html-loader!./index/upload-documentos-em-lote.index.html'),
                resolve: {
                    'access': accessResolve
                },
                controller: 'UploadDocumentosEmLoteIndexController',
                controllerAs: 'pldcmntslt_cntrllr'
            })
            .state('uploaddocumentoslote_new', {
                url: '/documentos/upload-em-lote/new',
                template: require('html-loader!./new/upload-documentos-em-lote.new.html'),
                resolve: {
                    'access': accessResolve
                },
                controller: 'UploadDocumentosEmLoteNewController',
                controllerAs: 'pldcmntslt_cntrllr_nw_cntrllr'
            })
            .state('uploaddocumentoslote_show', {
                url: '/documentos/upload-em-lote/show/{uploaddocumento}',
                template: require('html-loader!./show/upload-documentos-em-lote.show.html'),
                resolve: showResolve,
                controller: 'UploadDocumentosEmLoteShowController',
                controllerAs: 'pldcmntslt_cntrllr_shw_cntrllr'
            });
    }
];
